import { PageRes } from "../types/page";

type Status = "loading" | "valid" | "error" | "empty";

export const pageDataStatus = (
  pageData: PageRes,
  festivalHub: boolean = false
): Status => {
  const noCmsData =
    (Object.values(pageData?.page || {})
      .flat()
      .filter(Boolean) as any) == pageData?.page?.path;

  if (!pageData && !pageData?.meta) return "loading";

  if (!!pageData && noCmsData && !festivalHub) return "empty";

  if ((!!pageData && pageData?.meta?.status === 200) || !festivalHub)
    return "valid";

  if (!!pageData && (pageData?.meta?.status !== 200 || !!pageData?.error))
    return "error";

  return "empty";
};
